import { useMutation } from "@tanstack/react-query";
import { setUser } from "../../store/actions/accountInfo";
import { makeBackendGetCallWithJsonResponse } from "../../store/utils/fetch";
import User from "../../store/models/user";
import { VERIFY_EMAIL } from "../../store/utils/routes";
import queryString from "query-string";
import {
  displayEngineEarsError,
  promiseEngineEarsHandler,
} from "../../api/helpers";
import { useAppDispatch } from "../../store/hooks";

interface VerifyEmailArgs {
  verification: string;
  user_id: string;
  send_verification_code?: boolean;
}

const useVerifyAccountMutation = () => {
  const dispatch = useAppDispatch();
  return useMutation({
    mutationKey: ["verify_email"],
    mutationFn: (args: VerifyEmailArgs) => {
      return makeBackendGetCallWithJsonResponse<User>(
        VERIFY_EMAIL,
        `?${queryString.stringify(args, { skipEmptyString: true, skipNull: true })}`,
      )
        .then(promiseEngineEarsHandler)
        .then((user) => {
          dispatch(setUser(user));
          return user;
        })
        .catch((err) => {
          // Always show the toast and re-raise the error
          displayEngineEarsError(err);
          throw err;
        });
    },
  });
};

export default useVerifyAccountMutation;
